export const MUTATE = 'MUTATE';
export const MUTATE_OBJECT_KEY = 'MUTATE_OBJECT_KEY';
export const MUTATE_MULTIPLE = 'MUTATE_MULTIPLE';
export const MUTATE_REMOVE_OBJECT_KEY = 'MUTATE_REMOVE_OBJECT_KEY';
export const MUTATE_REMOVE_OBJECTS_FROM_ARRAY_BY_ATTRIBUTE_AND_VALUE = 'MUTATE_REMOVE_OBJECTS_FROM_ARRAY_BY_ATTRIBUTE_AND_VALUE';
